<script>

 /**
  * Depending on the settings, either renders a simple input for phone numbers, or the international phone number input component
  */
  import Input from './input.vue'
  import IntlPhoneInput from './intl-phone-input.vue'

  export const PHONE_INPUT_SETTINGS = {
    allowInternational: false,
    defaultRegion: null,
  }

  export default {

    functional: true,
    inheritAttrs: false,

    render(h, context) {

      let component = PHONE_INPUT_SETTINGS.allowInternational ? IntlPhoneInput : Input

      // Forward slots to component's relevant slot outlets (via templates with the appropriate slot name) 
      let children = Object.keys(context.slots()).map(slot => h('template', { slot }, context.slots()[slot]))
      
      let defaultsAttrs = {
        defaultCountry: PHONE_INPUT_SETTINGS.defaultRegion, // used by `intl-phone-input`
        'phone-number': true, // validator attribute
        type: 'tel',
        inputmode: 'tel',
        autocomplete: 'tel',
      }

      context.data.attrs = Object.assign(defaultsAttrs, context.data.attrs)

      return h(component, context.data, children)
    }
  }
</script>